import { EuiComment, EuiButton } from "@elastic/eui";
import styled from "styled-components";

export const StyledComment = styled(EuiComment)`
    */ span {
        width: 40px;
        height: 40px;
        background: #f5f7fa;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
    }

    .editor {
        box-sizing: border-box;
        border: 1px solid #ddd;
        cursor: text;
        padding: 16px;
        border-radius: 2px;
        margin-bottom: 2em;
        box-shadow: inset 0px 1px 8px -3px #ababab;
        background: #fefefe;
    }

    .editor :global(.public-DraftEditor-content) {
        min-height: 140px;
    }
    .styled-reply-button {
        position: absolute !important;
        right: 0;
        top: 50%;
        transform: translateY(-50%) !important;
    }
    .styled-reply-button.euiButtonEmpty--primary:enabled:focus {
        background: transparent !important;
    }
`;
export const CommentSubmitButton = styled(EuiButton)`
    position: absolute;
    right: 20px;
    bottom: 20px;
    background: #0583da !important;
    color: #fff !important;
    border-radius: 3px !important;
    text-transform: capitalize;
    text-decoration: none !important;
`;
